import gql from "graphql-tag";

const GET_CONTENT_FRAGMENT = `
	grid{
		Cols:cols
		Rows:rows
	}
	ref
	name
	style{
		bgColor,
		duration,
		fgColor,
		images{
			externalUrl,
			libraryRef
		}
		margin{
			W
			H
		},
		itemsMargin{
			W
			H
		},
		opacity
		useHomeBackground
	}
	widgets{
		id
		widgets{
			id
			widgets{
				id
				type
				position{
					X
					Y
				}
				size{
					W
					H
				}
				actions{
					type
					value
				}
				fonts{
					externalUrl
					libraryRef
					name
				}
				style
				config{
					carousel{
						adjust
						duration
						automatic
						images{
							externalUrl
							libraryRef
						}
						statistics{
							statistics
							statisticsFirstTime
							statisticsId
							statisticsOpenFirstTime
						}
					}
					container{
						grid{
							Cols:cols
							Rows:rows
						}
						itemsMargin{
							W
							H
						}
						margin{
							W
							H
						}
						resource{
							externalUrl
							libraryRef
						}
							statistics{
							statistics
							statisticsFirstTime
							statisticsId
							statisticsOpenFirstTime
						}
					}
					html{
						code{
							id
							text
						}
							statistics{
							statistics
							statisticsFirstTime
							statisticsId
							statisticsOpenFirstTime
						}
					}
					icon{
						icon
						lib
						size
						statistics{
							statistics
							statisticsFirstTime
							statisticsId
							statisticsOpenFirstTime
						}
					}
					iframe{
						url
						statistics{
							statistics
							statisticsFirstTime
							statisticsId
							statisticsOpenFirstTime
						}
					}
					image{
						adjust
						blur
						gradient
						opacity
						src{
							externalUrl
							libraryRef
						}
							statistics{
							statistics
							statisticsFirstTime
							statisticsId
							statisticsOpenFirstTime
						}
					}
					qr{
						predefined
						url
						statistics{
							statistics
							statisticsFirstTime
							statisticsId
							statisticsOpenFirstTime
						}
					}
					text{
						text{
							id
							text
						}
							statistics{
							statistics
							statisticsFirstTime
							statisticsId
							statisticsOpenFirstTime
						}
					}
					video{
						autoplay
						repeat
						video{
							externalUrl
							libraryRef
						}
						statistics{
							statistics
							statisticsFirstTime
							statisticsId
							statisticsOpenFirstTime
						}
						alternativeContent{
							externalUrl
							libraryRef
							useVideoFrame
						}
					}
					weather{
						design
						location{
							country
							id
							name
						}
						unit
						statistics{
							statistics
							statisticsFirstTime
							statisticsId
							statisticsOpenFirstTime
						}
					}
					topbar{
						title{
							id
							text
						}
							statistics{
							statistics
							statisticsFirstTime
							statisticsId
							statisticsOpenFirstTime
						}
					}
					chatbutton{
						showIcon
						title{
							id
							text
						}
							statistics{
							statistics
							statisticsFirstTime
							statisticsId
							statisticsOpenFirstTime
						}
					}
					button{
						adjust
						icon
						image{
							externalUrl
							libraryRef
						}
						lib
						showIcon
						title{
							id
							text
						}
							statistics{
							statistics
							statisticsFirstTime
							statisticsId
							statisticsOpenFirstTime
						}
					}
					logo{
						adjust
						blur
						gradient
						opacity
						src{
							externalUrl
							libraryRef
						}
							statistics{
							statistics
							statisticsFirstTime
							statisticsId
							statisticsOpenFirstTime
						}
					}
					messages{
						adjust
						icon
						image{
							externalUrl
							libraryRef
							name
						}
						lib
						showIcon
						title{
							id
							text
						}
						statistics{
							statistics
							statisticsFirstTime
							statisticsId
							statisticsOpenFirstTime
						}	

					}
					wifilogin{
						text{
							id
							text
						}
							statistics{
							statistics
							statisticsFirstTime
							statisticsId
							statisticsOpenFirstTime
						}
					}
					slider{
						mode
						reelSize
						automatic
						simpleOption
						interval
						items {
						  id
						  visibility
						  name
						  text {
							id
							text
						  }
						statistics{
							statistics
							statisticsFirstTime
							statisticsId
							statisticsOpenFirstTime
						}
						  actions {
							type
							value
						  }
						  resource {
							externalUrl
							libraryRef
							name
						  }
						}
					}
					promo{
						adjust
						promoId
						
					}
				}
			}
			type
			position{
				X
				Y
			}
			size{
				W
				H
			}
			actions{
				type
				value
			}
			fonts{
				externalUrl
				libraryRef
				name
			}
			style
			config{
				carousel{
					adjust
					duration
					automatic
					images{
						externalUrl
						libraryRef
					}
						statistics{
							statistics
							statisticsFirstTime
							statisticsId
							statisticsOpenFirstTime
						}
				}
				container{
					grid{
						Cols:cols
						Rows:rows
					}
					itemsMargin{
						W
						H
					}
					margin{
						W
						H
					}
						resource{
						externalUrl
						libraryRef
						}
						statistics{
							statistics
							statisticsFirstTime
							statisticsId
							statisticsOpenFirstTime
						}
				}
				html{
					code{
						id
						text
					}
						statistics{
							statistics
							statisticsFirstTime
							statisticsId
							statisticsOpenFirstTime
						}
				}
				html{
					code{
						id
						text
					}
						statistics{
							statistics
							statisticsFirstTime
							statisticsId
							statisticsOpenFirstTime
						}
				}
				icon{
					icon
					lib
					size
					statistics{
							statistics
							statisticsFirstTime
							statisticsId
							statisticsOpenFirstTime
						}
				}
				iframe{
					url
					statistics{
							statistics
							statisticsFirstTime
							statisticsId
							statisticsOpenFirstTime
						}
				}
				image{
					adjust
					blur
					gradient
					opacity
					src{
						externalUrl
						libraryRef
					}
						statistics{
							statistics
							statisticsFirstTime
							statisticsId
							statisticsOpenFirstTime
						}
				}
				qr{
					predefined
					url
					statistics{
							statistics
							statisticsFirstTime
							statisticsId
							statisticsOpenFirstTime
						}
				}
				text{
					text{
						id
						text
					}
						statistics{
							statistics
							statisticsFirstTime
							statisticsId
							statisticsOpenFirstTime
						}
				}
				video{
					autoplay
					repeat
					video{
						externalUrl
						libraryRef
					}
					statistics{
						statistics
						statisticsFirstTime
						statisticsId
						statisticsOpenFirstTime
					}
					alternativeContent{
						externalUrl
						libraryRef
						useVideoFrame
					}
				}
				weather{
					design
					location{
						country
						id
						name
					}
					unit
					statistics{
							statistics
							statisticsFirstTime
							statisticsId
							statisticsOpenFirstTime
						}
				}
				topbar{
					title{
						id
						text
					}
						statistics{
							statistics
							statisticsFirstTime
							statisticsId
							statisticsOpenFirstTime
						}
				}
				chatbutton{
					showIcon
					title{
						id
						text
					}
						statistics{
							statistics
							statisticsFirstTime
							statisticsId
							statisticsOpenFirstTime
						}
				}
				button{
					adjust
					icon
					image{
						externalUrl
						libraryRef
					}
					lib
					showIcon
					title{
						id
						text
					}
						statistics{
							statistics
							statisticsFirstTime
							statisticsId
							statisticsOpenFirstTime
						}
				}
				logo{
					adjust
					blur
					gradient
					opacity
					src{
						externalUrl
						libraryRef
					}
						statistics{
							statistics
							statisticsFirstTime
							statisticsId
							statisticsOpenFirstTime
						}
				}
				messages{
					adjust
					icon
					image{
						externalUrl
						libraryRef
						name
					}
					lib
					showIcon
					title{
						id
						text
					}
						statistics{
							statistics
							statisticsFirstTime
							statisticsId
							statisticsOpenFirstTime
						}
				}
				wifilogin{
					text{
						id
						text
					}

				}
				slider{
					mode
					reelSize
					automatic
					simpleOption
					interval
					items {
					  id
					  statistics{
							statistics
							statisticsFirstTime
							statisticsId
							statisticsOpenFirstTime
						}
					  visibility
					  name
					  text {
						id
						text
					  }
					  actions {
						type
						value
					  }
					  resource {
						externalUrl
						libraryRef
						name
					  }
					}
				  }
				promo{
					adjust
					promoId
				}
			}
		}
		type
		position{
			X
			Y
		}
		size{
			W
			H
		}
		actions{
			type
			value
		}
		fonts{
			externalUrl
			libraryRef
			name
		}
		style
		config{
			carousel{
				adjust
				duration
				automatic
				images{
					externalUrl
					libraryRef
				}
					statistics{
							statistics
							statisticsFirstTime
							statisticsId
							statisticsOpenFirstTime
						}
			}
			container{
				grid{
					Cols:cols
					Rows:rows
				}
				itemsMargin{
					W
					H
				}
				margin{
					W
					H
				}
				resource{
					externalUrl
					libraryRef
				}
					statistics{
							statistics
							statisticsFirstTime
							statisticsId
							statisticsOpenFirstTime
						}
			}
			html{
				code{
					id
					text
				}
					statistics{
							statistics
							statisticsFirstTime
							statisticsId
							statisticsOpenFirstTime
						}
			}
			icon{
				icon
				lib
				size
				statistics{
							statistics
							statisticsFirstTime
							statisticsId
							statisticsOpenFirstTime
						}
			}
			iframe{
				url
				statistics{
							statistics
							statisticsFirstTime
							statisticsId
							statisticsOpenFirstTime
						}
			}
			image{
				adjust
				blur
				gradient
				opacity
				src{
					externalUrl
					libraryRef
				}
					statistics{
							statistics
							statisticsFirstTime
							statisticsId
							statisticsOpenFirstTime
						}
			}
			qr{
				predefined
				url
				statistics{
							statistics
							statisticsFirstTime
							statisticsId
							statisticsOpenFirstTime
						}
			}
			text{
				text{
					id
					text
				}
					statistics{
							statistics
							statisticsFirstTime
							statisticsId
							statisticsOpenFirstTime
						}
			}
			video{
				autoplay
				repeat
				video{
					externalUrl
					libraryRef
				}
				statistics{
					statistics
					statisticsFirstTime
					statisticsId
					statisticsOpenFirstTime
				}
				alternativeContent{
					externalUrl
					libraryRef
					useVideoFrame
				}
			}
			weather{
				design
				location{
					country
					id
					name
				}
				unit
				statistics{
							statistics
							statisticsFirstTime
							statisticsId
							statisticsOpenFirstTime
						}
			}
			topbar{
				title{
					id
					text
				}
					statistics{
							statistics
							statisticsFirstTime
							statisticsId
							statisticsOpenFirstTime
						}
			}
			chatbutton{
				showIcon
				title{
					id
					text
				}
					statistics{
							statistics
							statisticsFirstTime
							statisticsId
							statisticsOpenFirstTime
						}
			}
			button{
				adjust
				icon
				image{
					externalUrl
					libraryRef
				}
				lib
				showIcon
				title{
					id
					text
				}
					statistics{
							statistics
							statisticsFirstTime
							statisticsId
							statisticsOpenFirstTime
						}
			}
			logo{
				adjust
				blur
				gradient
				opacity
				src{
					externalUrl
					libraryRef
				}
					statistics{
							statistics
							statisticsFirstTime
							statisticsId
							statisticsOpenFirstTime
						}
			}
			messages{
				adjust
				icon
				image{
					externalUrl
					libraryRef
					name
				}
				lib
				showIcon
				title{
					id
					text
				}
					statistics{
							statistics
							statisticsFirstTime
							statisticsId
							statisticsOpenFirstTime
						}
			}
			wifilogin{
				text{
					id
					text
				}
			}
			slider{
				mode
				reelSize
				automatic
				simpleOption
				interval
				items {
				  id
				  visibility
				  name
				  statistics{
						statistics
						statisticsFirstTime
						statisticsId
						statisticsOpenFirstTime
					}
				  text {
					id
					text
				  }
				  actions {
					type
					value
				  }
				  resource {
					externalUrl
					libraryRef
					name
				  }
				}
			}
			promo{
				adjust
				promoId
			}
		}
	}
`;

export const GET_HOTELS = {
    query: gql`
        query getProjects($page: Int!, $size: Int!) {
            getProjects(page: $page, size: $size) {
                results {
                    appAvailable
                    ref
                    name
                    location
                    photo
                    mobilePath
                    chatURL
                    chatPublic
                    isBookmarked
                    keyBrand
                    timeZone
                    permissionsConfig {
                        manageGuests
                        registeredUsers
                        topology
                        landing
                        sales
                        myOrders
                        shopsOrders
                        preCheckIn
                        messaging
                    }
                }
            }
        }
    `,
    defaultVars: { page: 1, size: 1000 },
};

export const GET_HOTEL = {
    query: gql`
        query getProject($ref: ID!, $roomNumber: Int, $password: String) {
            getProject(ref: $ref, roomNumber: $roomNumber, password: $password) {
                name
                designRef
                sales
                maps
                mapsGoogle {
                    apiKey
                }
                permissionsConfig {
                    manageGuests
                    landing
                    sales
                    myOrders
                    shopsOrders
                    preCheckIn
                    registeredUsers
                    topology
                    messaging
                }
                hasOnPremisesInterface
                VODDomain
                landing {
                    ref
                    style {
                        images {
                            externalUrl
                            libraryRef
                            name
                        }
                        bgColor
                    }
                }
                expressCheckout {
                    ref
                }
                theme {
                    colors {
                        defaultBackground
                        defaultForeground
                        activeBackground
                        activeForeground
                        focusBackground
                        focusForeground
                    }
                    fonts {
                        heading {
                            alignment
                            bold
                            font {
                                name
                                externalUrl
                                libraryRef
                            }
                            italic
                            size
                            underline
                        }
                        paragraph {
                            alignment
                            bold
                            font {
                                name
                                externalUrl
                                libraryRef
                            }
                            italic
                            size
                            underline
                        }
                    }
                    logos {
                        imageRef
                        type
                        version
                    }
                }
                cuiner {
                    appId
                    token
                    url
                    user
                }
            }
        }
    `,
};

export const GET_PORTAL = {
    query: gql`
        query getProject($ref: ID!) {
            getProject(ref: $ref) {
				name
				designRef
                VODDomain
				theme{
					colors{
						defaultBackground
						defaultForeground
						activeBackground
						activeForeground
						focusBackground
						focusForeground
					}
					fonts{
						heading{
							alignment
							bold
							font{
								name
								externalUrl
								libraryRef
							}
							italic
							size
							underline
						}
						paragraph{
							alignment
							bold
							font{
								name
								externalUrl
								libraryRef
							}
							italic
							size
							underline
						}
					}
					logos{
						imageRef
						type
						version
					}
				}
				portal{
					accessConditions
					privacyPolicy
					askMarketing
					authGoogle{
						web {
							clientID
						}
					}
					desktop{
						${GET_CONTENT_FRAGMENT}
					}
					mobile{
						${GET_CONTENT_FRAGMENT}
					}
				}
            }
        }
    `,
};

export const GET_CONTENT = {
    query: gql`
        query getContent($ref: ID!,$designRef: String!, $hotelRef: ID!, $roomNumber: Int, $password: String) {
            getContent(ref: $ref, designRef: $designRef, hotelRef: $hotelRef, roomNumber: $roomNumber, password: $password) {
				${GET_CONTENT_FRAGMENT}
            }
        }
    `,
};

export const GET_PMS_STATUS = {
    query: gql`
        query getPMSStatus($hotelRef: ID!) {
            getPMSStatus(hotelRef: $hotelRef)
        }
    `,
};
